import { useNavigate } from 'react-router-dom';
import { HANDLES_VIDEO_URL } from '@pomoshnik/shared';
import { Header } from '@/components/Header/Header';
import { BottomBar } from '@/components/BottomBar/BottomBar';
import { VideoButton } from '@/components/VideoButton';

/**
 * Экран 2.4.1 — выбор раздела «Ручки» / «Крючки» (PRD §06).
 *
 * После клика → переход на /handles/handle или /handles/hook (singular kind
 * соответствует Zod-схеме из Phase 1; см. TODO в `docs/architecture/BACKLOG.md`
 * про URL namespace).
 *
 * Phase 5 backfill (B-008): первым элементом контента — `<VideoButton>`
 * (PRD §16.4 — на entry-экранах функций видео-инструкция обязательна).
 */
export function KindPicker() {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen flex flex-col bg-canvas">
      <Header title="Что подбираем?" />

      <div className="flex-1 flex flex-col gap-4 p-6">
        <VideoButton videoUrl={HANDLES_VIDEO_URL} />
        <KindButton label="Ручки" onClick={() => navigate('/handles/handle')} />
        <KindButton label="Крючки" onClick={() => navigate('/handles/hook')} />
      </div>

      <BottomBar />
    </main>
  );
}

interface KindButtonProps {
  label: string;
  onClick: () => void;
}

function KindButton({ label, onClick }: KindButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={
        'min-h-tap-chip-lg w-full rounded-xl bg-card border-[1.5px] border-accent ' +
        'text-ink font-display text-h2 shadow-card ' +
        'focus-visible:ring-2 focus-visible:ring-cta focus-visible:outline-none active:opacity-90'
      }
      style={{ minHeight: 120 }}
    >
      {label}
    </button>
  );
}
